import clsx from 'clsx'
import React from 'react'
import { TLangs } from '../../../../translations/types';
import { useTranslation } from 'react-i18next';

type TProps = {
  lang: TLangs;
};

export const LanguageSelectItem: React.FC<TProps> = ({lang}) => {
  const { t, i18n } = useTranslation();
  const activeLang = i18n.language;

  return (
    <div onClick={() => i18n.changeLanguage(lang)} className={clsx('lang', {'active-lang': lang === activeLang})}>{lang}</div>
  )
}
